import type { Story } from '@/store/story-types'

export const LINK_IN_BIO_CLASSIC_STORY: Story = {
  id: 'link-in-bio-classic',
  name: 'Classic Link-in-Bio',
  narrative: 'A minimalist link-in-bio page with a profile card, social icons, and link buttons — inspired by Linktree and Bio.Site.',
  goals: ['Display creator profile and avatar', 'Showcase social media links', 'Drive traffic to external URLs'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-main', title: 'Jessica Kim', order: 0, status: 'draft', elementCount: 3, linkedPageId: 'main',
      description: 'Single-page bio with profile card, link buttons list, and footer',
      blockRef: { category: 'bio', blockId: 'bio-profile' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Profile',
      description: 'Visitor lands on the bio page and sees the creator profile',
      steps: [
        { type: 'given', text: 'the visitor opens the link-in-bio page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the profile card with avatar, name, and bio description is visible', linkedPageId: 'main' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Links',
      description: 'Visitor sees available link buttons',
      steps: [
        { type: 'given', text: 'the visitor is on the bio page', linkedPageId: 'main' },
        { type: 'when', text: 'they scroll down' },
        { type: 'then', text: 'a list of link buttons with labels and icons is displayed', linkedPageId: 'main' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Click External Link',
      description: 'Visitor taps a link button to navigate externally',
      steps: [
        { type: 'given', text: 'the visitor sees the link buttons', linkedPageId: 'main' },
        { type: 'when', text: 'they tap a link button' },
        { type: 'then', text: 'the browser navigates to the external URL', linkedFlowId: 'navigateExternal' },
      ],
    },
  ],
}
